import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { Config } from "@/settings/Config";

@Module({
  name: "searchModule",
})
export default class SearchModule extends VuexModule {
  public static readonly persisted = ["SearchModule._searchHistory"];

  private readonly config = new Config();

  private _searchFilter: string = "";
  private _searchHistory: string[] = [];
  private _searchModalOpen = false;

  public get searchFilter(): string {
    return this._searchFilter;
  }

  public get searchHistory(): string[] {
    return this._searchHistory;
  }

  public get searchModalOpen(): boolean {
    return this._searchModalOpen;
  }

  @Mutation
  setSearchFilter(value: string): void {
    this._searchFilter = value;
  }

  @Mutation
  setSearchModalOpen(value: boolean): void {
    this._searchModalOpen = value;
  }

  @Mutation
  addSearchKeyword(keyword: string): void {
    const history = this._searchHistory.slice();

    if (history.indexOf(keyword) === -1) {
      // New keyword
      if (history.length === this.config.searchHistoryMaxItem) {
        // History full, remove last item
        history.splice(history.length - 1, 1);
      }
      // Add to beginning of array
      history.unshift(keyword);
    } else if (keyword.length && history.indexOf(keyword) !== -1) {
      // Keyword exists => move it to the top
      const history = this._searchHistory.slice();
      const index = history.indexOf(keyword);

      if (index !== -1) {
        history.splice(index, 1);
        this._searchHistory = history;
      }
      history.unshift(keyword);
    }

    this._searchHistory = history;
  }

  @Mutation
  removeSearchKeyword(keyword: string) {
    const history = this._searchHistory.slice();
    const index = history.indexOf(keyword);

    if (index !== -1) {
      history.splice(index, 1);
      this._searchHistory = history;
    }
  }
}
